<template>
  <section id="pesanan-sukses">
    <Navbar />
    <div class="container">
      <div class="row text-center">
        <div class="col">
          <img
            :src="image"
            alt="img-food"
            class="img-fluid rounded"
            width="400px"
          />
          <h1><strong>Pesanan Sukses</strong>, Harap Tunggu</h1>
          <router-link class="btn btn-md btn-success mt-3" to="/foods">
            <b-icon icon="cart"></b-icon> Pesan Lagi
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import ImgPesanSukses from "../assets/images/menunggu.png";

export default {
  name: "PesananSukses",
  components: {
    Navbar,
  },
  data() {
    return {
      image: ImgPesanSukses,
    };
  },
};
</script>

<style></style>
